export const exportsTranslations = {
  export_download_title: 7938,
  export_download_description: 7937,
  export_download_submit: 7936,
  export_download_cancel: 7935,
  export_title: 7872,
  export_success: 7873,
  exports_no_data: 7879,
  exports_number_of_cases_single: 7890,
  exports_number_of_cases_multi: 7889
};

export const endpoint = {
  loadExportStatus: 'case/export/status',
  downloadCaseExportPackage: 'case/export'
};

export const exportStatusPollingInterval = 5000;
